var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"sr-only",attrs:{"href":"#main"}},[_vm._v(_vm._s(_vm.$t("r_skip_navigation")))]),_c('keep-alive',{attrs:{"include":"NagsCatalogue"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }